// extracted by mini-css-extract-plugin
export default {"tableTitle":"UICard_tableTitle__kt8d5","title":"UICard_title__lJhZ-","cardContainer":"UICard_cardContainer__tzKWh","dataWrapper":"UICard_dataWrapper__UT4O4"};